import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import {
  getProviderInitials,
  getProviderTheme,
  hasEsimWarning,
} from "../constants";
import { isDisplayableAutomatedBillValue } from "./automatedBillsUtils";

function ProviderLogo({ image, title }) {
  const initials = getProviderInitials(title);

  if (!image) {
    return <span>{initials}</span>;
  }

  return <img src={image} alt={title || "Provider"} />;
}

export default function BillProviderCard({
  historyButtonLabel,
  historyOnly = false,
  provider,
  viewMode = "grid",
  onAction,
  onHistory,
}) {
  const buttons = Array.isArray(provider?.Buttons) ? provider.Buttons : [];
  const theme = getProviderTheme(provider?.Title);
  const showWarning = hasEsimWarning(provider?.Title);
  const hasDescription = isDisplayableAutomatedBillValue(provider?.Description);

  return (
    <article
      className={`bills-page__provider-card card h-100 is-${viewMode}${
        historyOnly ? " is-history-only" : ""
      }`}
      style={{
        "--bill-accent": theme.accent,
        "--bill-surface": theme.surface,
      }}
    >
      <div className="bills-page__provider-main">
        <div className="bills-page__provider-brand d-flex gap-3">
          <div className="bills-page__provider-logo">
            <ProviderLogo image={provider?.Image} title={provider?.Title} />
          </div>

          <div className="bills-page__provider-copy">
            <h3>{provider?.Title || "Bill provider"}</h3>
            {hasDescription ? <p>{provider.Description}</p> : null}
          </div>
        </div>

        <div className="bills-page__provider-actions">
          {!historyOnly ? (
            <div className="bills-page__provider-buttons">
              {buttons.map((button, index) => (
                <button
                  key={`${button?.Slug || button?.Label || "action"}-${index}`}
                  type="button"
                  className={`btn bills-page__provider-button ${
                    button?.IsHalf ? "is-half" : "is-full"
                  }`}
                  onClick={() => onAction?.(button?.Slug, provider)}
                  disabled={!button?.Slug}
                >
                  {button?.Label || "Continue"}
                </button>
              ))}
            </div>
          ) : null}

          {provider?.MainButtonLabel ? (
            <button
              type="button"
              className="bills-page__history-button btn"
              onClick={() => onHistory?.(provider)}
            >
              {historyButtonLabel || provider.MainButtonLabel}
            </button>
          ) : null}
        </div>
      </div>

      {showWarning ? (
        <div className="bills-page__provider-warning d-inline-flex align-items-center gap-2">
          <FontAwesomeIcon icon={faTriangleExclamation} />
          <span>Make sure your device supports eSIM.</span>
        </div>
      ) : null}
    </article>
  );
}
